import { createContext, useContext } from "react";

/** Interface */
interface IAnnotatedLightboxContext {
	annotatedFileIds: Set<string>;
}

/** Context */
export const AnnotatedLightboxContext = createContext<IAnnotatedLightboxContext>({
	annotatedFileIds: new Set(),
});

export function useAnnotatedLightbox() {
	return useContext(AnnotatedLightboxContext);
}
